/* eslint-disable jsx-a11y/anchor-is-valid */
// import clsx from 'clsx'
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {Licenses} from '../../core/_models'

type Props = {
  Licenses: Licenses
}

const LicensesStatus: FC<Props> = ({Licenses}) => {
  const intl = useIntl()

  return (
    <div className='d-flex text-center justify-content-center'>
      <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-primary mb-1'>
          {Licenses.status === 'valid' && (
            <div
              className='badge badge-success fw-semibold '
              style={{
                whiteSpace: 'pre-line',
                fontSize: '8px',
              }}
            >
              {intl.formatMessage({id: 'LICENSES.STATUS_1'})}
            </div>
          )}
          {Licenses.status === 'waiting_license' && (
            <div
              className='badge badge-light-success fw-semibold fs-9'
              style={{
                whiteSpace: 'pre-line',
                fontSize: '8px',
              }}
            >
              {intl.formatMessage({
                id: 'LICENSES.STATUS_2',
              })}
            </div>
          )}
          {Licenses.status === 'in_renovation' && (
            <div
              className='badge badge-warning fs-9'
              style={{
                whiteSpace: 'pre-line',
                fontSize: '8px',
              }}
            >
              {intl.formatMessage({id: 'LICENSES.STATUS_3'})}
            </div>
          )}
          {Licenses.status === 'renewed_replaced' && (
            <div
              className='badge badge-light-info fw-semibold fs-9'
              style={{
                whiteSpace: 'pre-line',
                fontSize: '8px',
              }}
            >
              {intl.formatMessage({id: 'LICENSES.STATUS_4'})}
            </div>
          )}
          {Licenses.status === 'finished' && (
            <div
              className='badge badge-light-dark  fw-semibold fs-9'
              style={{
                whiteSpace: 'pre-line',
                fontSize: '8px',
              }}
            >
              {intl.formatMessage({id: 'LICENSES.STATUS_5'})}
            </div>
          )}
          {Licenses.status === 'expired' && (
            <div
              className='badge badge-danger fw-semibold fs-9'
              style={{
                whiteSpace: 'pre-line',
                fontSize: '8px',
              }}
            >
              {intl.formatMessage({id: 'LICENSES.STATUS_6'})}
            </div>
          )}
          {Licenses.status === 'changed_ownership' && (
            <div
              className='badge badge-light-success fw-semibold fs-9'
              style={{
                whiteSpace: 'pre-line',
                fontSize: '8px',
              }}
            >
              {intl.formatMessage({id: 'LICENSES.STATUS_7'})}
            </div>
          )}
          {Licenses.status === 'waiting_documentation' && (
            <div
              className='badge badge-warning fw-semibold fs-9'
              style={{
                whiteSpace: 'pre-line',
                fontSize: '8px',
              }}
            >
              {intl.formatMessage({id: 'LICENSES.STATUS_8'})}
            </div>
          )}
        </a>
      </div>
    </div>
  )
}
export {LicensesStatus}
